<div class="reset-password-container">
  <div class="card-wrapper">
    <div class="card">
      <div class="card-header">
        <div class="logo-container">
          <img src="assets/AivorLogo.png" alt="Aivor Logo" class="logo">
        </div>
        <h1 class="title">Reset Password</h1>
        <p class="subtitle">Enter your new password below</p>
      </div>

      <div class="card-body">
        <div *ngIf="checkingToken" class="loading-container">
          <div class="spinner">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Checking token validity...</span>
            </div>
          </div>
          <p class="loading-text">Verifying your reset token...</p>
        </div>

        <form (submit)="onSubmit($event)" *ngIf="!checkingToken && tokenValid" class="reset-form">
          <div class="form-group">
            <label for="newPassword" class="form-label">New Password</label>
            <div class="form-group">

              <div class="input-group">
                <input
                id="newPassword"
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                [(ngModel)]="newPassword"
                name="newPassword"
                placeholder="Enter your password"
                required
                #password="ngModel"
              />

              <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
            >
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>

            </div>

          </div>

          <div class="form-group">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <div class="input-group">
              <input
              id="confirmPassword"
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              placeholder="Enter your password"
              required
              #password="ngModel"
            />

            <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="togglePasswordVisibility()"
            tabindex="-1"
          >
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>

          </div>

          <button  type="submit" class="btn-primary" [disabled]="loading || newPassword !== confirmPassword || newPassword === ''" >
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ loading ? 'Resetting...' : 'Reset Password' }}
          </button>

          <div *ngIf="errorMessage" class="alert alert-error">
            <i class="fas fa-exclamation-circle"></i>
            {{ errorMessage }}
          </div>

          <div *ngIf="successMessage" class="alert alert-success">
            <i class="fas fa-check-circle"></i>
            {{ successMessage }}
          </div>
        </form>

        <div *ngIf="!checkingToken && !tokenValid" class="alert alert-error">
          <i class="fas fa-exclamation-circle"></i>
          Invalid or expired reset token. Please request a new password reset.
        </div>

        <div class="form-footer">

          <button type="button" class="btn btn-primary" (click)="goToLogin()">Back to Login</button>
        </div>
      </div>
    </div>
  </div>
</div>
